import { useEffect, useRef } from 'react';
import { useMyLanguage } from '@/src/hooks/useMyLanguage';
import { TranslateLayer } from '@/src/lib/translateLayer';

/** Turns on whole-app translation when the person's language (Settings › Language) isn't English. */
export default function TranslationHost() {
  const { language, ready } = useMyLanguage();
  const layer = useRef<TranslateLayer | null>(null);
  const was = useRef<string | null>(null);
  useEffect(() => {
    if (!ready) return;
    const lang = language && language !== 'en' ? language : null;
    if (was.current && was.current !== lang) {
      // Switching language (or back to English): start clean so no old translations are left on screen.
      layer.current?.stop();
      window.location.reload();
      return;
    }
    was.current = lang;
    if (!lang || layer.current) return;
    layer.current = new TranslateLayer(lang);
    void layer.current.start();
  }, [language, ready]);
  useEffect(() => () => layer.current?.stop(), []);
  return null;
}
